import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useSalaryRevisionGroups } from 'contexts/salary-revision-groups'
import { Header, Heading } from './s'
import Badge from 'components/badge'
import { CloseButton } from 'components/button'
import Groups from 'lists/salary/side-panel-revision-groups'

const RevisionGroups = ({ dismiss, salt }) => {
    const { total } = useSalaryRevisionGroups()

    return (
        <>
            <Header>
                <Heading className="compact">
                    <FormattedMessage
                        id="salary_revision_heading_groups"
                        defaultMessage="Active revision groups" />
                </Heading>
                <Badge number={total} />
                <CloseButton onClick={dismiss} />
            </Header>
            <Groups salt={salt} />
        </>
    )
}

export default RevisionGroups